import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useFetchDynamicDataTableDataQuery,
  useUpdateDynamicDataTableDataMutation,
} from "../../utils/customer/customerTaskTable";
import useRequireAuth from "../../utils/useRequireAuth";
import { useFetchDynamicHeaderQuery } from "../../utils/customer/customerTaskTable";
import CustomerListTable from "../customer/CustomerListTable";
import SideBar from "../Dashboard/SideBar";
import AddCurrency from "./AddCurrency";
import HeaderDashboard from "../HeaderDashboard";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { ReactComponent as ExpandCollapsIMG } from "../../assets/images/expandCollapsIMG.svg";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
// import { useDispatch, useSelector } from "react-redux"
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";

const DynamicListTable = () => {
  const { id: value } = useParams();
  const [customer, setCustomer] = useState([]);
  const { token } = useRequireAuth();
  const [customerTablePagination, setCustomerTablePagination] = useState(null);
  const [initialFilter, setInitialFilter] = useState([]);
  const navigate = useNavigate();
  const [header, setHeader] = useState();
  const [editData, setEditData] = useState();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [totalData, setTotalData] = useState("");
  const dispatch = useDispatch();

  const { data: customerTableALL, refetch: refetchCustomerData } = useFetchDynamicDataTableDataQuery({
    dynamicId: value,
    token: token,
    pagination: `${customerTablePagination}`,
  });
  const [updateDynamicTable] = useUpdateDynamicDataTableDataMutation();

  useEffect(() => {
    if (customerTableALL) {
      const { data, ...restData } = customerTableALL?.data;

      const newEdit = {
        field_name: "action",
        field_options: null,
        id: 99,
        table_name: null,
        type: null,
        value: "Delete",
      };
      setCustomer([...data, newEdit]);
      setTotalData(customerTableALL?.data?.total);
      setInitialFilter(restData);
      setTotalData(customerTableALL?.data?.total);
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData]);

  const {
    data: customerHeader,
    refetch,
    isFetching,
  } = useFetchDynamicHeaderQuery({
    dynamicId: value,
    token: token,
  });

  const handleNavigate = (taskid) => {
    if (taskid) {
      setIsEditPopupOpen(true);
      setEditData(taskid);
    }
  };
  useEffect(() => {
    if (customerTablePagination) {
      refetchCustomerData();
    }
  }, [customerTablePagination]);

  useEffect(() => {
    if (customerHeader) {
      const generateDynamicArray = ({ data: { header } = {} }) => {
        if (!header) return [];
        return header.map((field) => ({
          [field]: field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
          [`${field}_status`]: 1,
        }));
      };
      const result = generateDynamicArray(customerHeader);
      setHeader([...result]);
    }
  }, [customerHeader]);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const closePopup = () => {
    setEditData();
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
  };
  const handelsave = () => {
    refetchCustomerData();
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const removeUnderscores = (str) => {
    if (str != "") {
      return str.replace(/_/g, " ");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleDeleteGroup = (data) => {
    const payload = {
      field_name: data?.customer_id?.field_name,
      id: data?.customer_id?.value,
    };
    updateDynamicTable({ data: payload, token });
    dispatch(pushAlert({ type: "success", message: "Business Caterory Deleted Successfully", visible: true }));
  };

  useEffect(() => {
    if (isFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetching]);

  return (
    <>
      <div className="flex flex-col gap-2 justify-around h-screen ">
        <HeaderDashboard />
        <FirstMessage type={alert.type} message={alert.message} visible={alert.visible} onHide={hideAlert} />
        <div className="px-4 h-full">
          <div class="flex grid-rows-2 gap-10 h-full">
            <div className="w-1/5">
              <SideBar />
            </div>

            <div className="w-9/12 h-full flex flex-col">
              <div className="flex absolute mb-1">
                <button className="font-medium text-16 text-203C50 capitalize" onClick={handleBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  {customerHeader?.data?.tableName ? removeUnderscores(customerHeader?.data?.tableName) : null}
                </button>
              </div>
              <CustomerListTable
                totalData={totalData}
                tableDetail={{
                  tableidclass: "fullscreen-table",
                  tableHeading: customerHeader?.data?.tableName
                    ? removeUnderscores(customerHeader?.data?.tableName)
                    : null,
                  tableparentidclass: "tableparent",
                  tablenameclass: "font-medium text-16 text-203C50 capitalize",
                  tableSearch: true,
                  tableHeading: customerHeader?.data?.tableName
                    ? removeUnderscores(customerHeader?.data?.tableName)
                    : null,
                  tableFilter: true,
                  refetchCustomerData: { refetchCustomerData },
                  forcefullyfreeze: true,
                  tableResizer: false,
                  tableZoom: true,
                  tableheader: false,
                  dataactivity: true,
                  headeraddfield: false,
                  rowDisable: true,
                  addbutton: (
                    <ToolTipComponent text="Add">
                      <button onClick={openPopup} type="button" className="text-2541558A hover:text-254155">
                        <PlusIcon isActive={isPopupOpen} />
                      </button>
                    </ToolTipComponent>
                  ),
                  actionfield: (data) =>
                    data?.customer_id?.field_name !== "company_groups" && (
                      <Fragment>
                        <td className="w-[50px]">
                          <div className="text-left pl-[10px]">
                            <button onClick={() => handleDeleteGroup(data)} className="text-F84545 text-15 text-left">
                              {" "}
                              <i class="bi bi-trash3 text-18 text-F84545 font-600"></i>{" "}
                            </button>
                          </div>
                        </td>
                      </Fragment>
                    ),
                }}
                thead={header}
                tbody={customer}
                tablePaginationData={setCustomerTablePagination}
                initialFilter={initialFilter}
                handleNavigate={handleNavigate}
                navigateNameCondition={[customerHeader?.data?.header[0]]}
                // ExtraFieldComponent={{
                //   action: (
                //     <Fragment>
                //          <h1>werwr</h1>
                //     </Fragment>
                //   )
                // }}
              />
            </div>
          </div>
        </div>
      </div>
      <nav className="">
        <div className="container ">
          <div class="flex justify-between ">
            <div class="flex justify-between ">
              <div class="tablemaindiv customerTaskTable">
                {isPopupOpen && (
                  <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                    <AddCurrency
                      closePopup={closePopup}
                      dataName={customerHeader?.data?.tableName}
                      tableId={value}
                      handelsave={handelsave}
                    />
                  </div>
                )}
                {editData && (
                  <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                    <AddCurrency
                      closePopup={closePopup}
                      dataName={customerHeader?.data?.tableName}
                      currencyId={editData}
                      tableId={value}
                      handelsave={handelsave}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="md:hidden">
            <button className="text-white focus:outline-none">
              <ExpandCollapsIMG className="w-6 h-6" />
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};
export default DynamicListTable;
